export const showProductDetails = (id) => ({
    type: 'PRODUCT_DETAILS_SHOW',
    id
});

export const hideProductDetails = () => ({
    type: 'PRODUCT_DETAILS_HIDE'
});